'use client'

import { createContext, useContext, useMemo, useState } from 'react'

interface PageHeaderContextValue {
  title: string | null
  setTitle: (title: string | null) => void
}

const PageHeaderContext = createContext<PageHeaderContextValue | undefined>(undefined)

export function PageHeaderProvider({ children }: { children: React.ReactNode }) {
  const [title, setTitle] = useState<string | null>(null)

  const value = useMemo(
    () => ({
      title,
      setTitle,
    }),
    [title]
  )

  return (
    <PageHeaderContext.Provider value={value}>
      {children}
    </PageHeaderContext.Provider>
  )
}

export function usePageHeader() {
  const context = useContext(PageHeaderContext)
  if (!context) {
    throw new Error('usePageHeader must be used within a PageHeaderProvider')
  }
  return context
}

